/* global axios */

const accountId = () => {
  if (window.location.pathname.includes('/app/accounts')) {
    return window.location.pathname.split('/')[3];
  }
  return '';
};

const baseUrl = () =>
  `/api/v1/accounts/${accountId()}/aceleres/contact_ownership_requests`;

let requestSequence = 0;
const freshParams = (params = {}) => {
  requestSequence += 1;
  return {
    params: { ...params, cache_bust: `${Date.now()}-${requestSequence}` },
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
  };
};

export default {
  pending() {
    return axios.get(baseUrl(), freshParams({ status: 'pending' }));
  },
  team() {
    return axios.get(baseUrl(), freshParams());
  },
  approve(id) {
    return axios.post(`${baseUrl()}/${id}/approve`);
  },
  reject(id) {
    return axios.post(`${baseUrl()}/${id}/reject`);
  },
};
